module.exports = __webpack_public_path__ + "img/edit.47dde5ec.svg";